import { Switch, Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  Admin as AdminLayout,
  SystemParticipant as SystemParticipantLayout,
  SystemParticipantNotAllowed as SystemParticipantNotAllowedLayout,
  SystemParticipantNoOrganization as SystemParticipantNoOrganizationLayout,
} from "./layouts";
import routes from "./routes";
import { useTranslation } from "react-i18next";
import PermissionRequired from "./layouts/PermissionRequired";
import { setStations } from "./redux/actions/stations";
import { useState } from "react";

export default function PrivateRoutes() {
  const { t } = useTranslation();
  const authUser = useSelector((state) => state.authorization.user);

  const permissionEnabled = process.env.REACT_APP_PERMISSION_ENABLED;

  const routeHandler = (route) => {
    if (
      (authUser.organization.yekgLicenseType === "RETAIL" ||
        authUser.organization.yekgLicenseType === "K1") &&
      route.path === "/export-transactions"
    ) {
      return false;
    }
    if (
      !authUser.organization.marketParticipationAgreement &&
      (route.path === "/offer-operations" ||
        route.path === "/offers-and-matches" ||
        route.path === "/market-results" ||
        route.path === "/objections")
    ) {
      return false;
    }
    return true;
  };

  return (
    <>
      {authUser.roles.includes("ADMIN") && (
        <AdminPrivateRoutes
          authUser={authUser}
          t={t}
          routes={routes}
          permissionEnabled={permissionEnabled}
        />
      )}
      {authUser.roles.includes("USER") && (
        <SystemParticipantPrivateRoutes
          authUser={authUser}
          t={t}
          routes={routes}
          routeHandler={routeHandler}
          permissionEnabled={permissionEnabled}
        />
      )}
    </>
  );
}

function AdminPrivateRoutes({ t, routes, authUser, permissionEnabled }) {
  return (
    <Route
      render={({ location }) => (
        <AdminLayout location={location} t={t}>
          <Switch>
            {routes.admin.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                exact={route.exact}
                component={(props) => {
                  if (permissionEnabled) {
                    if (
                      route.permissions.filter((item) => {
                        return authUser.userPermissions
                          ? authUser.userPermissions.includes(item)
                          : null;
                      }).length > 0
                    ) {
                      return route.component({ t: t, ...props });
                    } else {
                      return PermissionRequired({
                        location: location,
                        t: t,
                      });
                    }
                  } else {
                    return route.component({ t: t, ...props });
                  }
                }}
              />
            ))}
            <Route render={() => <Redirect to="/" />} />
          </Switch>
        </AdminLayout>
      )}
    />
  );
}
function SystemParticipantPrivateRoutes({
  authUser,
  t,
  routeHandler,
  routes,
  permissionEnabled,
}) {
  if (authUser.organization) {
    if (
      authUser.organization.yekgOrganizationStatus === "ACTIVE" ||
      authUser.organization.yekgOrganizationStatus === "PASSIVE" ||
      authUser.organization.yekgOrganizationStatus === "PARTIAL_PASSIVE"
    ) {
      return (
        <Route
          render={({ location }) => (
            <SystemParticipantLayout location={location} t={t}>
              <Switch>
                {routes.systemParticipant.map((route, index) => {
                  if (routeHandler(route))
                    return (
                      <Route
                        key={index}
                        path={route.path}
                        exact={route.exact}
                        component={(props) => {
                          if (permissionEnabled) {
                            if (
                              route.permissions.filter((item) => {
                                return authUser.userPermissions
                                  ? authUser.userPermissions.includes(item)
                                  : null;
                              }).length > 0
                            ) {
                              return route.component({ t: t, ...props });
                            } else {
                              return PermissionRequired({
                                location: location,
                                t: t,
                              });
                            }
                          } else {
                            return route.component({ t: t, ...props });
                          }
                        }}
                      />
                    );
                  return null;
                })}
                <Route render={() => <Redirect to="/" />} />
              </Switch>
            </SystemParticipantLayout>
          )}
        />
      );
    }
    if (authUser.organization.yekgOrganizationStatus === "") {
      return (
        <Route
          render={({ location }) => (
            <SystemParticipantNotAllowedLayout
              location={location}
              t={t}
            ></SystemParticipantNotAllowedLayout>
          )}
        />
      );
    }
  } else {
    return (
      <Route
        render={({ location }) => (
          <SystemParticipantNoOrganizationLayout
            location={location}
            t={t}
          ></SystemParticipantNoOrganizationLayout>
        )}
      />
    );
  }
}
